/* eslint-disable react-hooks/exhaustive-deps */
import {Grid, TextField} from "@material-ui/core";
import {localize} from "commons/LocalizedText/LocalizedText";
import {AutoCompleteWithValue} from "commons/AutoComplete/AutoCompleteWithValue";
import React, {useEffect} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {MOBILE_BREAKPOINT} from "utils/constants/responsive";
import useQueryState from "hook/UseQueryState";
import {QueryStringToJSONObject} from "utils/helpers/QueryStringHelper";
import {ParamTypes} from "utils/constants/param.type";
import {UserService} from "services/UserService";
import {useQuery} from "hook/UseQuery";
import useFetch from "hook/UseFetch";
import {LaboratoryService} from "services/LaboratoryService";
import {ProgramService} from "services/ProgramService";
import PropTypes from "prop-types";
import {useDebouncedValue} from "utils/form/debouncer";

const useStyles = makeStyles((theme) => ({
  divider: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
      marginBottom: theme.spacing(1)
    }
  },
  inputFields: {
    maxWidth: 600,
    width: '-webkit-fill-available',
    marginLeft: '20px'
  }
}));

export const LaboUserSearch = ({updateFilter, withCompany = true}) => {
  const classes = useStyles();
  const query = useQuery();
  const statusesOptions = useFetch(() => UserService.getUserStatusesNames(), []).response;
  const companiesOptions = useFetch(() => LaboratoryService.getLaboratoriesNames(), []).response;
  const programsOptions = useFetch(() => ProgramService.getAllProgramsNames(), []).response;
  const rolesOptions = useFetch(() => UserService.getUserRolesNames(), []).response;

  const [mailOrLogin, setMailOrLogin] = useQueryState(
    'mailOrLogin',
    QueryStringToJSONObject(window.location.search.substring(1)).mailOrLogin || '',
    ParamTypes.STRING
  );
  const [name, setName] = useQueryState(
    'name',
    QueryStringToJSONObject(window.location.search.substring(1)).name || '',
    ParamTypes.STRING
  );
  const [firstname, setFirstname] = useQueryState(
    'firstname',
    QueryStringToJSONObject(window.location.search.substring(1)).firstname || '',
    ParamTypes.STRING
  );
  const [selectedCompanies, setSelectedCompanies] =  useQueryState(
    'selectedCompanies',
    QueryStringToJSONObject(window.location.search.substring(1)).selectedCompanies || [],
    ParamTypes.ARRAY
  );
  const [selectedPrograms, setSelectedPrograms] = useQueryState(
    'selectedPrograms',
    QueryStringToJSONObject(window.location.search.substring(1)).selectedPrograms || [],
    ParamTypes.ARRAY
  );
  const [selectedStatus, setSelectedStatus] =  useQueryState(
    'selectedStatus',
    query.get("selectedStatus") || statusesOptions[0] || 'Enabled',
    ParamTypes.STRING
  );
  const [selectedRoles, setSelectedRoles] = useQueryState(
    'selectedRoles',
    QueryStringToJSONObject(window.location.search.substring(1)).selectedRoles || [],
    ParamTypes.ARRAY
  );

  const debouncedSearchFilterMail = useDebouncedValue(mailOrLogin, 500);
  const debouncedSearchFilterLastName = useDebouncedValue(name, 500);
  const debouncedSearchFilterFirstName = useDebouncedValue(firstname, 500);

  useEffect(() => {
    updateFilter({
      selectedRoles,
      selectedStatus,
      selectedPrograms,
      selectedCompanies,
      firstname,
      name,
      mailOrLogin
    });
  }, [selectedCompanies,
    selectedPrograms,
    selectedStatus,
    selectedRoles,
    debouncedSearchFilterLastName,
    debouncedSearchFilterFirstName,
    debouncedSearchFilterMail]);

  return (
    <div>
      <Grid
        container>
        <Grid
          alignItems="flex-end"
          container
          direction="row"
          justifyContent="space-evenly"
          spacing={10}
          wrap='nowrap'
        >
          <Grid item
            xs={6}
          >
            <TextField
              className={classes.inputFields}
              fullWidth
              onChange={e => setMailOrLogin(e.target.value)}
              placeholder={localize('mailOrLogin')}
              type="text"
              value={mailOrLogin}
            />
          </Grid>
          <Grid item
            marginLeft='10px'
            marginRight='10px'
            xs={6}
          >
            <TextField
              className={classes.inputFields}
              fullWidth
              onChange={e => setName(e.target.value)}
              placeholder={localize('name')}
              type="text"
              value={name}
            />
          </Grid>
          <Grid item
            marginLeft='10px'
            marginRight='10px'
            xs={6}
          >
            <TextField
              className={classes.inputFields}
              fullWidth
              onChange={e => setFirstname(e.target.value)}
              placeholder={localize('firstname')}
              type="text"
              value={firstname}
            />
          </Grid>
        </Grid>
        <Grid
          alignItems="flex-end"
          container
          direction="row"
          spacing={1}
          wrap='nowrap'>
          { withCompany && (
            <Grid item
              xs={8}
            >
              <AutoCompleteWithValue
                className={classes.inputFields}
                isMultiple
                label="company"
                limitTags={3}
                onChange={value => setSelectedCompanies(value)}
                options={companiesOptions}
                value={selectedCompanies}
              />
            </Grid>
          )}
          <Grid item
            xs={8}
          >
            <AutoCompleteWithValue
              className={classes.inputFields}
              isMultiple
              label="program"
              limitTags={3}
              onChange={value => setSelectedPrograms(value)}
              options={programsOptions}
              value={selectedPrograms}
            />
          </Grid>
          <Grid item
            xs={3}
          >
            <AutoCompleteWithValue
              className={classes.inputFields}
              isTranslatingOptions
              label="status"
              onChange={value => setSelectedStatus(value)}
              options={statusesOptions}
              value={selectedStatus}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
        >
          <AutoCompleteWithValue
            className={classes.inputFields}
            isMultiple
            isTranslatingOptions
            label="contactProfile"
            onChange={value => setSelectedRoles(value)}
            options={rolesOptions}
            value={selectedRoles}
          />
        </Grid>
      </Grid>
    </div>
  );
};

LaboUserSearch.propTypes = {updateFilter : PropTypes.func.isRequired}